import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Button} from 'primeng/button';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {ProgressSpinner} from 'primeng/progressspinner';
import {ApiPoliciesService} from '../../../shared/api/api.policies.service';
import {ApiUsersService} from '../../../shared/api/api.users.service';
import {AuthService} from '../../../shared/auth/services/auth.service';
import {
    PolicyModalMode,
    PolicyModalService,
} from '../../../shared/auth/services/policy-modal.service';
import {DEFAULT_LOCALE} from '../../../wappy/languages/language.config';
import {Policy} from '../domain/policy';

@Component({
    selector: 'app-policy-modal',
    standalone: true,
    imports: [CommonModule, Button, ProgressSpinner, TranslatePipe],
    templateUrl: './policy-modal.component.html',
    styleUrl: './policy-modal.component.css',
})
export class PolicyModalComponent implements OnInit {
    private readonly config = inject(DynamicDialogConfig);
    private readonly authService = inject(AuthService);
    private readonly policyModalService = inject(PolicyModalService);
    private readonly apiPoliciesService = inject(ApiPoliciesService);
    private readonly apiUsersService = inject(ApiUsersService);

    readonly mode: PolicyModalMode = this.config.data.mode;
    policy: Policy | null = null;
    loading = true;
    accepting = false;

    ngOnInit(): void {
        this.loadPolicy();
    }

    private loadPolicy(): void {
        const langCode = this.authService.getApiUser()?.locale ?? DEFAULT_LOCALE;

        this.apiPoliciesService.getLatestByKey('app_terms', langCode).subscribe({
            next: policy => {
                this.policy = policy;
                this.loading = false;
            },
            error: error => {
                console.error('Error cargando la política de aplicación:', error);
                this.loading = false;
            },
        });
    }

    accept(): void {
        if (!this.policy || this.accepting) {
            return;
        }

        this.accepting = true;
        this.apiPoliciesService.acceptTerms().subscribe({
            next: () => {
                this.apiUsersService.getMe().subscribe({
                    next: user => {
                        this.authService.setApiUser(user);
                        this.policyModalService.close();
                    },
                    error: error => {
                        console.error('Error recargando el usuario tras aceptar la política:', error);
                        this.policyModalService.close();
                    },
                });
            },
            error: error => {
                console.error('Error aceptando la política de aplicación:', error);
                this.accepting = false;
            },
        });
    }

    logout(): void {
        this.policyModalService.close();
        this.authService.logout();
    }
}
